import * as angular from 'angular';

import { svgIconTemplates } from '@mode/shared/util-js';

export class SvgIconController implements angular.IController {
  static $inject = ['$element'];

  type!: string;
  iconTemplate = '';

  constructor(private $element: angular.IAugmentedJQuery) {}

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes['type']) {
      this.setIconTemplate();
    }
  }

  setIconTemplate() {
    switch (this.type) {
      case 'copy-link':
        this.iconTemplate = svgIconTemplates.copyLinkIcon;
        break;
      case 'toggle-explorer':
        this.iconTemplate = svgIconTemplates.explorerIcon;
        break;
      case 'toggle-expanded-view':
        this.iconTemplate = svgIconTemplates.expandedViewIcon; // For example, see lines 104-105 in big-number-component.ts
        break;
      case 'kebab':
        this.iconTemplate = svgIconTemplates.kebabIcon;
        break;
      case 'filter':
        this.iconTemplate = svgIconTemplates.filterIcon;
        break;
      case 'back':
        this.iconTemplate = svgIconTemplates.backIcon;
        break;
      case 'forward':
        this.iconTemplate = svgIconTemplates.forwardIcon;
        break;
      case 'cancel-find':
        this.iconTemplate = svgIconTemplates.cancelFindIcon;
        break;
      case 'clear-filter':
        this.iconTemplate = svgIconTemplates.clearFilterIcon;
        break;
      case 'hierarchy-down':
        this.iconTemplate = svgIconTemplates.hierarchyDown;
        break;
      case 'hierarchy-up':
        this.iconTemplate = svgIconTemplates.hierarchyUp;
        break;
      case 'modal-close':
        this.iconTemplate = svgIconTemplates.modalClose;
        break;
      case 'ph-notebook':
        this.iconTemplate = svgIconTemplates.placeholderNotebook;
        break;
      case 'ph-big-number':
        this.iconTemplate = svgIconTemplates.placeholderBigNumber;
        break;
      case 'ph-pie':
        this.iconTemplate = svgIconTemplates.placeholderPie;
        break;
      case 'ph-donut':
        this.iconTemplate = svgIconTemplates.placeholderDonut;
        break;
      case 'ph-line':
        this.iconTemplate = svgIconTemplates.placeholderLine;
        break;
      case 'ph-line-bar':
        this.iconTemplate = svgIconTemplates.placeholderLineBar;
        break;
      case 'ph-area':
        this.iconTemplate = svgIconTemplates.placeholderArea;
        break;
      case 'ph-area-100':
        this.iconTemplate = svgIconTemplates.placeholderArea100;
        break;
      case 'ph-bar':
        this.iconTemplate = svgIconTemplates.placeholderBar;
        break;
      case 'ph-bar-100':
        this.iconTemplate = svgIconTemplates.placeholderBar100;
        break;
      case 'ph-bar-h':
        this.iconTemplate = svgIconTemplates.placeholderBarH;
        break;
      case 'ph-bar-h-100':
        this.iconTemplate = svgIconTemplates.placeholderBarH100;
        break;
      case 'ph-bar-grouped':
        this.iconTemplate = svgIconTemplates.placeholderBarGrouped;
        break;
      case 'ph-bar-h-grouped':
        this.iconTemplate = svgIconTemplates.placeholderBarHGrouped;
        break;
      case 'ph-table':
        this.iconTemplate = svgIconTemplates.placeholderTable;
        break;
      case 'ph-scatter':
        this.iconTemplate = svgIconTemplates.placeholderScatter;
        break;
      case 'report-icon':
        this.iconTemplate = svgIconTemplates.reportIconInExploreHeader;
        break;
      case 'first-page':
        this.iconTemplate = svgIconTemplates.firstPage;
        break;
      case 'previous-page':
        this.iconTemplate = svgIconTemplates.previousPage;
        break;
      case 'last-page':
        this.iconTemplate = svgIconTemplates.lastPage;
        break;
      case 'next-page':
        this.iconTemplate = svgIconTemplates.nextPage;
        break;
      case 'table-no-rows':
        this.iconTemplate = svgIconTemplates.tableNoRows;
        break;
      case 'new-tab':
        this.iconTemplate = svgIconTemplates.newTab;
        break;
      case 'empty-exploration':
        this.iconTemplate = svgIconTemplates.emptyExploration;
        break;
      case 'empty-line':
        this.iconTemplate = svgIconTemplates.emptyVizLine;
        break;
      case 'empty-total-area':
        this.iconTemplate = svgIconTemplates.emptyVizTotalArea;
        break;
      case 'empty-bar':
        this.iconTemplate = svgIconTemplates.emptyVizBar;
        break;
      case 'empty-h-bar':
        this.iconTemplate = svgIconTemplates.emptyVizHBar;
        break;
      case 'empty-stacked-bar':
        this.iconTemplate = svgIconTemplates.emptyVizStackedBar;
        break;
      case 'empty-stacked-bar-100':
        this.iconTemplate = svgIconTemplates.emptyVizStackedBar100;
        break;
      case 'empty-h-stacked-bar':
        this.iconTemplate = svgIconTemplates.emptyVizHStackedBar;
        break;
      case 'empty-h-stacked-bar-100':
        this.iconTemplate = svgIconTemplates.emptyVizHStackedBar100;
        break;
      case 'empty-area':
        this.iconTemplate = svgIconTemplates.emptyVizArea;
        break;
      case 'empty-line-plus-bar':
        this.iconTemplate = svgIconTemplates.emptyVizLinePlusBar;
        break;
      case 'empty-donut':
        this.iconTemplate = svgIconTemplates.emptyVizDonut;
        break;
      case 'empty-pie':
        this.iconTemplate = svgIconTemplates.emptyVizPie;
        break;
      case 'empty-table':
        this.iconTemplate = svgIconTemplates.emptyVizTable;
        break;
      case 'empty-scatter':
        this.iconTemplate = svgIconTemplates.emptyVizScatter;
        break;
      case 'empty-big-value':
        this.iconTemplate = svgIconTemplates.emptyVizBigValue;
        break;
      case 'error-line':
        this.iconTemplate = svgIconTemplates.errorVizLine;
        break;
      case 'error-total-area':
        this.iconTemplate = svgIconTemplates.errorVizTotalArea;
        break;
      case 'error-bar':
        this.iconTemplate = svgIconTemplates.errorVizStackedBar;
        break;
      case 'error-h-bar':
        this.iconTemplate = svgIconTemplates.errorVizHBar;
        break;
      case 'error-stacked-bar':
        this.iconTemplate = svgIconTemplates.errorVizStackedBar;
        break;
      case 'error-stacked-bar-100':
        this.iconTemplate = svgIconTemplates.errorVizStackedBar100;
        break;
      case 'error-h-stacked-bar':
        this.iconTemplate = svgIconTemplates.errorVizHBar;
        break;
      case 'error-h-stacked-bar-100':
        this.iconTemplate = svgIconTemplates.errorVizHStackedBar100;
        break;
      case 'error-area':
        this.iconTemplate = svgIconTemplates.errorVizArea;
        break;
      case 'error-line-plus-bar':
        this.iconTemplate = svgIconTemplates.errorVizLinePlusBar;
        break;
      case 'error-donut':
        this.iconTemplate = svgIconTemplates.errorVizDonut;
        break;
      case 'error-pie':
        this.iconTemplate = svgIconTemplates.errorVizPie;
        break;
      case 'error-table':
        this.iconTemplate = svgIconTemplates.errorVizTable;
        break;
      case 'error-scatter':
        this.iconTemplate = svgIconTemplates.errorVizScatter;
        break;
      case 'error-big-value':
        this.iconTemplate = svgIconTemplates.errorVizBigValue;
        break;
      case 'error-viz-explorer':
        this.iconTemplate = svgIconTemplates.errorVizVizExplorer;
        break;
      case 'my-explorations':
        this.iconTemplate = svgIconTemplates.explorationsDefault;
        break;
      case 'my-explorations-active':
        this.iconTemplate = svgIconTemplates.explorationsActive;
        break;
      case 'explorations-list-empty':
        this.iconTemplate = svgIconTemplates.explorationsListEmpty;
        break;
      case 'explorations-list-not-found':
        this.iconTemplate = svgIconTemplates.explorationsListNotFound;
        break;
      case 'edit-exploration':
        this.iconTemplate = svgIconTemplates.editExploration;
        break;
      case 'edit-exploration-active':
        this.iconTemplate = svgIconTemplates.editExplorationActive;
        break;
      case 'field-list-boolean-discrete':
        this.iconTemplate = svgIconTemplates.fieldListBooleanDiscrete;
        break;
      case 'field-list-boolean-discrete-calc':
        this.iconTemplate = svgIconTemplates.fieldListBooleanDiscreteCalc;
        break;
      case 'field-list-date-continuous':
        this.iconTemplate = svgIconTemplates.fieldListDateContinuous;
        break;
      case 'field-list-date-continuous-calc':
        this.iconTemplate = svgIconTemplates.fieldListDateContinuousCalc;
        break;
      case 'field-list-date-discrete':
        this.iconTemplate = svgIconTemplates.fieldListDateDiscrete;
        break;
      case 'field-list-date-discrete-calc':
        this.iconTemplate = svgIconTemplates.fieldListDateDiscreteCalc;
        break;
      case 'field-list-invalid-calc':
        this.iconTemplate = svgIconTemplates.fieldListInvalidCalc;
        break;
      case 'field-list-numeric-continuous':
        this.iconTemplate = svgIconTemplates.fieldListNumericContinuous;
        break;
      case 'field-list-numeric-continuous-calc':
        this.iconTemplate = svgIconTemplates.fieldListNumericContinuousCalc;
        break;
      case 'field-list-numeric-discrete':
        this.iconTemplate = svgIconTemplates.fieldListNumericDiscrete;
        break;
      case 'field-list-numeric-discrete-calc':
        this.iconTemplate = svgIconTemplates.fieldListNumericDiscreteCalc;
        break;
      case 'field-list-string-discrete':
        this.iconTemplate = svgIconTemplates.fieldListStringDiscrete;
        break;
      case 'field-list-string-discrete-calc':
        this.iconTemplate = svgIconTemplates.fieldListStringDiscreteCalc;
        break;
      case 'return-arrow-icon':
        this.iconTemplate = svgIconTemplates.returnArrowIcon;
        break;
      case 'chevron-icon':
        this.iconTemplate = svgIconTemplates.chevronIcon;
        break;
      case 'chevron-thin':
        this.iconTemplate = svgIconTemplates.chevronThin;
        break;
      case 'collection-icon':
        this.iconTemplate = svgIconTemplates.collectionIcon;
        break;
      case 'data-icon':
        this.iconTemplate = svgIconTemplates.dataIcon;
        break;
      case 'eye-icon':
        this.iconTemplate = svgIconTemplates.eyeIcon;
        break;
      case 'globe-icon':
        this.iconTemplate = svgIconTemplates.globeIcon;
        break;
      case 'home-icon':
        this.iconTemplate = svgIconTemplates.homeIcon;
        break;
      case 'padlock-icon':
        this.iconTemplate = svgIconTemplates.padlockIcon;
        break;
      case 'pencil-icon':
        this.iconTemplate = svgIconTemplates.pencilIcon;
        break;
      case 'pencil-icon-empty':
        this.iconTemplate = svgIconTemplates.pencilIconEmpty;
        break;
      case 'rocket-icon':
        this.iconTemplate = svgIconTemplates.rocketIcon;
        break;
      case 'star-icon':
        this.iconTemplate = svgIconTemplates.starIcon;
        break;
      case 'star-icon-filled':
        this.iconTemplate = svgIconTemplates.starIconFilled;
        break;
      case 'user-icon':
        this.iconTemplate = svgIconTemplates.userIcon;
        break;
      case 'sidebar-new-notebook':
        this.iconTemplate = svgIconTemplates.sidebarNewNotebook;
        break;
      case 'sidebar-r-notebook':
        this.iconTemplate = svgIconTemplates.sidebarRNotebook;
        break;
      case 'sidebar-python-notebook':
        this.iconTemplate = svgIconTemplates.sidebarPythonNotebook;
        break;
      case 'sidebar-query':
        this.iconTemplate = svgIconTemplates.sidebarQuery;
        break;
      case 'sidebar-imported-dataset':
        this.iconTemplate = svgIconTemplates.sidebarImportedDataset;
        break;
      case 'sidebar-report-builder':
        this.iconTemplate = svgIconTemplates.sidebarReportBuilder;
        break;
      case 'add-plus':
        this.iconTemplate = svgIconTemplates.addPlus;
        break;
      case 'add-plus-hover':
        this.iconTemplate = svgIconTemplates.addPlusHover;
        break;
      case 'add-plus-filled':
        this.iconTemplate = svgIconTemplates.addPlusFilled;
        break;
      case 'action-menu':
        this.iconTemplate = svgIconTemplates.actionMenu;
        break;
      case 'carat':
        this.iconTemplate = svgIconTemplates.carat;
        break;
      case 'layout-grid':
        this.iconTemplate = svgIconTemplates.layoutGrid;
        break;
      case 'layout-list':
        this.iconTemplate = svgIconTemplates.layoutList;
        break;
      case 'kebab-v2':
        this.iconTemplate = svgIconTemplates.kebabIconV2;
        break;
      case 'report-tile':
        this.iconTemplate = svgIconTemplates.reportTile;
        break;
      case 'video-link':
        this.iconTemplate = svgIconTemplates.videoLink;
        break;
      case 'blog-article':
        this.iconTemplate = svgIconTemplates.blogArticle;
        break;
      case 'question-mark':
        this.iconTemplate = svgIconTemplates.questionMark;
        break;
      case 'warning-exclamation-mark':
        this.iconTemplate = svgIconTemplates.warningExclamationMark;
        break;
      case 'info-icon':
        this.iconTemplate = svgIconTemplates.infoIcon;
        break;
      case 'circle':
        this.iconTemplate = svgIconTemplates.circle;
        break;
      case 'metric-badge':
        this.iconTemplate = svgIconTemplates.metricBadge;
        break;
      default:
        this.iconTemplate = '';
        break;
    }

    this.$element.html(this.iconTemplate);
  }
}

/**
 * @deprecated Prefer the `IconComponent`
 */
const SvgIconComponent = {
  controller: SvgIconController,
  controllerAs: 'ctrl',
  bindings: {
    type: '<',
  },
  template: '',
};

export { SvgIconComponent };
